import { ARIA_LABELS } from "@/config/constants";

/**
 * Skip navigation link — WCAG 2.4.1 (Bypass Blocks, Level A)
 *
 * Best practices applied:
 * - Visually hidden via transform (not left:-9999px) — CSS Tricks recommendation
 * - position: fixed — visible at top of viewport even when page is scrolled
 * - JS-enhanced focus: programmatic target.focus() fixes WebKit/Chromium quirk
 *   where anchor navigation alone doesn't move keyboard focus to non-interactive elements
 * - href="#main-content" preserved as fallback (works without JS, screen reader nav)
 *
 * Source: https://webaim.org/techniques/skipnav/
 * Source: https://css-tricks.com/how-to-create-a-skip-to-content-link/
 */
export function SkipLink() {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    const target = document.getElementById("main-content");
    if (!target) return;
    e.preventDefault();
    target.focus();
  };

  return (
    <a href="#main-content" className="skip-link" onClick={handleClick}>
      {ARIA_LABELS.skipToMain}
    </a>
  );
}
